/** 产品向 SVG 图标（无 emoji）— 色值对齐 web brand */

type P = { className?: string; size?: number };

const s = (size?: number) => ({ width: size ?? 22, height: size ?? 22 });

export function IconExplore({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
      <ellipse cx="12" cy="12" rx="4" ry="9" stroke="currentColor" strokeWidth="1.4" />
      <path d="M3 12h18M5 8h14M5 16h14" stroke="currentColor" strokeWidth="1.2" opacity="0.7" />
    </svg>
  );
}

export function IconOrders({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <rect x="5" y="3" width="14" height="18" rx="2.5" stroke="currentColor" strokeWidth="1.75" />
      <path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconEsim({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path
        d="M7 3h7l4 4v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <rect x="9" y="11" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10 8h4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function IconUser({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <circle cx="12" cy="9" r="3.5" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M5.5 19.5c1.2-3 3.5-4.5 6.5-4.5s5.3 1.5 6.5 4.5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconSearch({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.75" />
      <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

export function IconChevron({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size ?? 16)} fill="none" aria-hidden>
      <path
        d="M9 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconBack({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconCopy({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <rect x="8" y="8" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <path d="M6 15H5a2 2 0 01-2-2V5a2 2 0 012-2h8a2 2 0 012 2v1" stroke="currentColor" strokeWidth="1.75" />
    </svg>
  );
}

export function IconCheck({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" fill="#D1FAE5" />
      <path d="M8 12.5l2.5 2.5L16 9" stroke="#0F766E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconSim({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path d="M8 3h6l4 4v13a1 1 0 01-1 1H8a1 1 0 01-1-1V4a1 1 0 011-1z" fill="#EEF0FF" stroke="#5B5CE2" strokeWidth="1.4" />
      <rect x="9.5" y="11" width="5" height="4" rx="0.8" fill="#5B5CE2" opacity="0.85" />
    </svg>
  );
}

export function IconGlobeSoft({ className, size }: P) {
  return (
    <svg viewBox="0 0 44 44" className={className} style={s(size ?? 44)} fill="none" aria-hidden>
      <rect width="44" height="44" rx="12" fill="#EEF0FF" />
      <circle cx="22" cy="22" r="10" stroke="#5B5CE2" strokeWidth="1.8" />
      <ellipse cx="22" cy="22" rx="5" ry="10" stroke="#5B5CE2" strokeWidth="1.4" />
      <path d="M12 22h20" stroke="#5B5CE2" strokeWidth="1.3" opacity="0.8" />
    </svg>
  );
}

export function IconWallet({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <rect x="3" y="7" width="18" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.75" />
      <path d="M3 10h18" stroke="currentColor" strokeWidth="1.4" opacity="0.5" />
      <circle cx="16.5" cy="13.5" r="1.4" fill="currentColor" />
    </svg>
  );
}

export function IconCrypto({ className, size }: P) {
  return (
    <svg viewBox="0 0 32 32" className={className} style={s(size ?? 28)} fill="none" aria-hidden>
      <rect width="32" height="32" rx="10" fill="#EEF0FF" />
      <circle cx="16" cy="16" r="7" stroke="#5B5CE2" strokeWidth="1.8" />
      <path d="M16 11v10M13 13.5h4.5a1.8 1.8 0 010 3.6H13h5a1.8 1.8 0 010 3.6H13" stroke="#5B5CE2" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconShield({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path
        d="M12 3l8 3.5v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10v-6L12 3z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M9 12l2 2 4-4.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconClock({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
      <path d="M12 7v5.5l3.5 2" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

export function IconTelegram({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path
        d="M20.5 4.5L3.8 11c-1 .4-.9 1.8.1 2.1l4.2 1.3 1.6 5c.3 1 1.6 1.2 2.2.4l2.4-3.1 4.5 3.3c.8.6 2 .2 2.3-.8L21.8 6c.3-1.1-.7-2-1.3-1.5z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconChat({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path
        d="M5 6.5A2.5 2.5 0 017.5 4h9A2.5 2.5 0 0119 6.5v7a2.5 2.5 0 01-2.5 2.5H10l-3.5 3v-3H7.5A2.5 2.5 0 015 13.5v-7z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M9 9h6M9 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconDoc({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path
        d="M7 3h7l4 4v13a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M14 3v4h4M9 12h6M9 16h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconLogout({ className, size }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={s(size)} fill="none" aria-hidden>
      <path
        d="M10 5H7a2 2 0 00-2 2v10a2 2 0 002 2h3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path d="M14 12H7M14 12l3-3M14 12l3 3" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
